"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _4d_mapper_1 = require("4d-mapper");
const rxjs_1 = require("rxjs");
const Cesium = window.Cesium;
/**
 * an implmentation speicifc coordinate. Contains untis to convert from cesium to standard coords
 * as well as placeholders for holding the cesium cartesian coords so they dont need to be recalced
 */
class WMTSTransformRenderer extends _4d_mapper_1.Renderer {
    constructor(viewer) {
        super();
        this.viewer = viewer;
        this._log();
    }
    onAdd(t, args) {
        var url = t['url'] || t.file('WMTS');
        var layer = (args ? args.layer : null) || (t['proxyMeta'] ? t['proxyMeta'].layer_id : null);
        this._log('onAdd', [t, args, url, layer]);
        if (args && args.onInit) {
            args.onInit(t, { url, layer });
        }
        var shadedRelief1 = new Cesium.WebMapTileServiceImageryProvider({
            url: args ? args.url : url,
            layer: layer,
            style: 'default',
            format: 'image/jpeg',
            tileMatrixSetID: 'default028mm',
            parameters: {
                transparent: true,
                format: 'image/png'
            }
        });
        if (args && args.onStart) {
            args.onStart(t, shadedRelief1);
        }
        var obj = this.viewer.imageryLayers.addImageryProvider(shadedRelief1);
        if (args && args.onProcess) {
            args.onProcess(t, obj);
        }
        if (shadedRelief1.errorEvent) {
            this.monitorEvent('errorEvent', shadedRelief1.errorEvent);
        }
        var pr = {
            plottable: t,
            object: obj
        };
        if (args && args.onEnd) {
            args.onEnd(t, pr);
        }
        return rxjs_1.of(pr);
    }
    onRemove(t, pr) {
        this.viewer.imageryLayers.remove(pr.object);
    }
}
exports.WMTSTransformRenderer = WMTSTransformRenderer;
